<template>
	<div class="basic-info">
		<titles>
			<template #mainTitle>考试基本情况</template>
			<template #secondTitle>帮助您整体把握本次考试 学科的基本情况</template>
		</titles>
		<div class="info">
			本学科试卷共 <strong>{{ basicInfo.paperNum }}</strong> 道题目， 主观题 <strong>{{ basicInfo.ansNum }}</strong> 道，分值占比
			<strong>{{ basicInfo.ansPercent }}</strong
			>，客观题 <strong>{{ basicInfo.objNum }}</strong> 道，分值占比 <strong>{{ basicInfo.objPercent }}</strong> ；学科总分
			<strong>{{ basicInfo.totalScore }}</strong
			>。详细学科考试情况如下：
		</div>
		<div class="index">学科常用分析指标</div>
		<hm-table :tableOptions="tableOptions" :isTableShowMore="isTableShowMore"></hm-table>
	</div>
</template>

<script>
export default {
	name: 'basic-info',
	components: {
		titles: () => import('./title'),
		hmTable: () => import('hm-table')
	},
	props: {
		basicInfo: {
			type: Object,
			default: () => {}
		},
		isTableShowMore: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			tableOptions: []
		}
	},
	watch: {
		basicInfo: {
			handler(val) {
				this.tableOptions = []
				if (val.subTableOptions && val.subTableOptions.length > 0) {
					this.tableOptions = [val.subTableOptions]
				}
			},
			// immediate: true,
			deep: true
		}
	}
}
</script>

<style scoped lang="less">
.basic-info {
	padding: 30px 15px;
	background: white;
	.info {
		margin-top: 8px;
		font-size: 15px;
	}
	.index {
		font-size: 18px;
		margin-top: 15px;
		margin-bottom: 8px;
	}
	@media print {
		.info {
			font-size: 20px;
		}
		.index {
			font-size: 23px;
		}
	}
}
</style>
